<template>
  <div>
    <header>
      项目名称：
      <el-input
        v-model="searchKey"
        placeholder="请输入单位名称"
        style="width: 340px"
      ></el-input>状态：
      <el-select
        v-model="status"
        placeholder="请选择"
      >
        <el-option
          label="全部"
          value="-1"
        ></el-option>
        <el-option
          label="有效"
          value="1"
        ></el-option>
        <el-option
          label="无效"
          value="2"
        ></el-option> </el-select>项目类型：
      <el-select
        v-model="projectTyle"
        placeholder="请选择"
      >
        <el-option
          label="全部"
          :value="-1"
        ></el-option>
        <el-option
          :label="item.typeName"
          :value="item.id"
          v-for="item in projectTypeList"
          :key="item.id"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 10px"
        @click="getList()"
      >查询</el-button>
      <el-button
        type="primary"
        @click="openAdd()"
      >新增</el-button>
    </header>
    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column
        prop="projectName"
        label="项目名称"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="platFormType"
        label="授权平台类型"
        width="180"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="belongUnitName"
        label="公司名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="authorityProjectTypeName"
        label="项目类型"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="projectLeader"
        label="项目用户"
        align="center"
      ></el-table-column>
      <el-table-column
        label="授权模块"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="getModules(scope.row)"
          >配置模块</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="isFinish"
        label="属性"
        align="center"
      > <template slot-scope="scope">{{
          scope.row.isFinish ? "已结束" : "未结束"
        }}</template></el-table-column>
      <el-table-column
        label="状态"
        align="center"
      >
        <template slot-scope="scope">{{
          scope.row.status == 1 ? "有效" : "无效"
        }}</template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="edit(scope.row)"
          >编辑</el-button>
          <el-button
            type="text"
            @click="del(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="tc"
      style="margin-top: 20px"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>

    <el-dialog
      :title="editId ? '编辑' : '新增'"
      :visible.sync="addDialogVisible"
      width="1300px"
      center
      :close-on-click-modal="false"
      :before-close="handleClose"
      @close="dialogCloseFun"
    >
      <el-form
        ref="ruleForm"
        :model="form"
        label-width="160px"
        :rules="rules"
      >
        <el-form-item
          label="授权平台类型:"
          prop="platFormType"
        >
          <el-checkbox-group v-model="form.platFormType">
            <el-checkbox
              :label="item.id + ''"
              v-for="item in PlatList"
              :key="item.id"
            >{{ item.platFormName }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="项目名称:"
              prop="projectName"
            >
              <el-input v-model="form.projectName"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="项目所在地:"
              prop="address"
            >
              <el-cascader
                size="large"
                :options="options"
                v-model="form.selectedOptions"
              ></el-cascader>
              <el-input
                style="width: 228px; margin-left: 10px"
                v-model="form.address"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="项目简称:"
              prop="projectSimpleName"
            >
              <el-input v-model="form.projectSimpleName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="项目类型:"
              prop="authorityProjectTypeId"
            >
              <el-select
                v-model="form.authorityProjectTypeId"
                placeholder="请选择"
              >
                <el-option
                  :label="item.typeName"
                  :value="item.id"
                  v-for="item in projectTypeList"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="项目规模:"
              prop="projectArea"
            >
              <el-input
                v-model="form.projectArea"
                style="width: 220px; margin-right: 10px"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="所属单位名称:"
              prop="belongUnitName"
            >
              <el-select
                v-model="form.belongUnitName"
                placeholder="请选择"
                @change="handlerBelongUnit"
              >
                <el-option
                  v-for="item in belongUnitList"
                  :key="item.id"
                  :label="item.companyName"
                  :value="item.companyName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="所属单位类型:"
              prop="authorityUnitTypeId"
            >
              <el-select
                v-model="form.authorityUnitTypeId"
                placeholder="请选择"
              >
                <el-option
                  :label="item.typeName"
                  :value="item.id"
                  v-for="item in unitTypeList"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="统一社会信用代码:"
              prop="unitCode"
            >
              <el-input v-model="form.unitCode"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="施工许可证号:"
              prop="permitCode"
            >
              <el-input v-model="form.permitCode"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="账号:"
              prop="userAccount"
            >
              <el-input v-model="form.userAccount"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="密码:"
              prop="userPwd"
            >
              <el-input
                v-model="form.userPwd"
                show-password
                placeholder="请输入8-16位包含字母数字的密码"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="项目负责人:"
              prop="projectLeader"
            >
              <el-input v-model="form.projectLeader"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="项目负责人电话:"
              prop="projectLeaderPhone"
            >
              <el-input v-model="form.projectLeaderPhone"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="有效状态:"
              prop="status"
            >
              <el-radio
                v-model="form.status"
                :label="1"
              >有效</el-radio>
              <el-radio
                v-model="form.status"
                :label="2"
              >无效</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="短信推送:"
              prop="status"
            >
              <el-radio
                v-model="warnTodo.isGlobalOpen"
                :label="false"
              >不推送</el-radio>
              <el-radio
                v-model="warnTodo.isGlobalOpen"
                :label="true"
              >推送</el-radio>
              <button
                v-if="warnTodo.isGlobalOpen"
                class="pushInformation"
                @click="pushDialog($event)"
              >
                短信推送配置
              </button>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="项目属性:"
              prop="status"
            >
              <el-radio-group v-model="warnTodo.isFinish">
                <el-radio
                  @click.native.prevent="finishInput(1)"
                  :label="1"
                >项目已结束</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="手机号码:"
              prop="telephone"
            >
              <el-input v-model="form.telephone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >确定</el-button>
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="短信推送配置"
      :visible.sync="pushInformation"
      width="900px"
      center
      :close-on-click-modal="false"
      :before-close="handleCloseWarn"
    >
      <el-form label-width="100px">
        <el-row class="groupLists">
          <el-form-item label="推送模块:">
            <br />
            <el-checkbox-group
              v-model="warnListsId"
              @change="warnChecked()"
            >
              <el-checkbox
                :label="item.moduleId"
                v-for="item in warnLists"
                :key="item.moduleId"
              >{{ item.moduleName }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="推送规则:">
            <br />
            <el-col>短信推送频次：每24小时推送一次，推送时间20：00：00</el-col>
            <el-col>
              <el-checkbox
                v-model="warnTodo.isContinuationOpen"
                @change="handleCheckChange"
              >
                同一模块同一设备同种监测类型
                <el-select
                  v-model="warnTodo.continuationMinutes"
                  placeholder="请选择"
                  style="width: 100px"
                >
                  <el-option
                    v-for="type1 in selectList1"
                    :key="type1.value"
                    :label="type1.label"
                    :value="type1.value"
                  ></el-option> </el-select>分钟连续报警
                <el-input
                  v-model="warnTodo.continuationTimes"
                  style="width: 100px"
                  type="number"
                  placeholder="请输入"
                ></el-input>次进行推送

                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="contentText"
                  placement="top"
                >
                  <i
                    class="el-icon-warning"
                    type="primary"
                  ></i>
                </el-tooltip>
              </el-checkbox>
            </el-col>
            <el-col>
              <el-checkbox
                v-model="warnTodo.isProruptionOpen"
                @change="handleCheckChangeDay"
              >
                同一模块同一设备同种监测类型超过
                <el-select
                  v-model="warnTodo.proruptionDays"
                  placeholder="请选择"
                  style="width: 100px"
                >
                  <el-option
                    v-for="type2 in selectList2"
                    :key="type2.value"
                    :label="type2.label"
                    :value="type2.value"
                  ></el-option> </el-select>天无报警时，突发报警时推送
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="contentText"
                  placement="top"
                >
                  <i
                    class="el-icon-warning"
                    type="primary"
                  ></i>
                </el-tooltip>
              </el-checkbox>
            </el-col>
            <el-col v-if="warnTodo.isContinuationOpen || warnTodo.isProruptionOpen">
              每日短信推送条数上限
              <el-input
                v-model="warnTodo.dailyLimit"
                style="width: 100px"
                type="number"
                placeholder="请输入"
              ></el-input>
              <!-- @blur="limitNum()" -->
              （最多不能超过{{ warnTodo.maxLimit }}条），今日剩余短信推送数量：
              {{ warnTodo.dailySurplusCount }}
            </el-col>
          </el-form-item>
        </el-row>
        <el-form-item>
          <el-button
            type="primary"
            @click="warnSurePush"
          >确定</el-button>
          <el-button @click="cencelWarn()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- <authorization
      :isShow="authorizationShow"
      @isShow="closeAuthor"
      @selectModules='selectModules'
      :propsKey='propsKey'
      :setType="'all'"
    />-->
    <!-- :isShow="authorizationShow" -->
    <authorization
      ref="authorization"
      :isShow="authorizationShow"
      @isShow="closeAuthor"
      :haveID="haveID"
      :companyId="companyId"
      @selectModules="selectModules"
      :propsKey="propsKey"
      :setType="'superSetProject'"
    />
  </div>
</template>

<script>
// TODO companyID没改，需要确认
import { regionData } from "element-china-area-data";
import authorization from "@/components/authorization.vue";
import { validatorPassword } from '@/util/validateRules.js';
import { Api_SuperAdmin, Api_Base, Api_System } from "@/api/api";
import { getStore } from "@/util/store";
import mixin_dialog from "@/mixins/dialog.js";
import { getWarnData, pushWarnData } from "@/api/pubapi.js";
export default {
  components: {
    authorization,
  },
  mixins: [mixin_dialog],
  data() {
    return {
      options: regionData,
      totalCount: 0,
      currentPage: 1,
      pagesize: 10,
      projectTyle: -1,
      projectTypeList: [],
      selectedOptions: [],
      belongUnitList: [],
      getMoneyTypeList: [],
      unitTypeList: [],
      PlatList: [],
      searchKey: "",
      status: "-1",
      authorizationShow: false,
      tableData: [],
      addDialogVisible: false,
      form: {
        platFormType: [],
        status: 1,
        authorityCompanyId: 0,
      },
      selectList1: [
        {
          labele: 5,
          value: 5,
        },
        {
          labele: 10,
          value: 10,
        },
        {
          labele: 15,
          value: 15,
        },
        {
          labele: 20,
          value: 20,
        },
        {
          labele: 25,
          value: 25,
        },
        {
          labele: 30,
          value: 30,
        },
        {
          labele: 35,
          value: 35,
        },
        {
          labele: 40,
          value: 40,
        },
        {
          labele: 45,
          value: 45,
        },
        {
          labele: 50,
          value: 50,
        },
        {
          labele: 55,
          value: 55,
        },
        {
          labele: 60,
          value: 60,
        },
      ],
      selectList2: [
        {
          labele: 1,
          value: 1,
        },
        {
          labele: 2,
          value: 2,
        },
        {
          labele: 3,
          value: 3,
        },
        {
          labele: 4,
          value: 4,
        },
        {
          labele: 5,
          value: 5,
        },
        {
          labele: 6,
          value: 6,
        },
        {
          labele: 7,
          value: 7,
        },
        {
          labele: 8,
          value: 8,
        },
        {
          labele: 9,
          value: 9,
        },
        {
          labele: 10,
          value: 10,
        },
        {
          labele: 15,
          value: 15,
        },
        {
          labele: 20,
          value: 20,
        },
        {
          labele: 25,
          value: 25,
        },
        {
          labele: 30,
          value: 30,
        },
        {
          labele: 35,
          value: 35,
        },
        {
          labele: 40,
          value: 40,
        },
        {
          labele: 45,
          value: 45,
        },
        {
          labele: 50,
          value: 50,
        },
        {
          labele: 55,
          value: 55,
        },
        {
          labele: 60,
          value: 60,
        },
      ],
      originalPassword: '', // 新增：用于存储原始密码
      rules: {
        projectName: [
          {
            required: true,
            message: "请输入项目名称",
            trigger: "blur",
          },
          // { min: 1, max: 16, message: '长度不超过16个字符', trigger: 'blur' }
        ],
        projectSimpleName: [{
          required: true,
          message: "请输入项目简称",
          trigger: "blur",
        },
          //{ min: 1, max: 10, message: '长度不超过10个字符', trigger: 'blur' }
        ],
        platFormType: [
          {
            required: true,
            message: "请选择平台类型",
            trigger: "blur",
          },
        ],
        authorityProjectTypeId: [
          {
            required: true,
            message: "请选择项目类型",
            trigger: "blur",
          },
        ],
        authorityCompanyId: [
          {
            required: true,
            message: "请选择所属单位",
            trigger: "blur",
          },
        ],
        projectArea: [
          {
            required: true,
            message: "请选择项目规模",
            trigger: "blur",
          },
        ],
        authorityUnitTypeId: [
          {
            required: true,
            message: "请选择所属单位类型",
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: "blur",
          },
        ],
        address: [
          {
            required: true,
            message: "请输入地址",
            trigger: "blur",
          },
        ],
        unitCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur",
          },
        ],
        companyLeader: [
          {
            required: true,
            message: "请输入公司法人",
            trigger: "blur",
          },
        ],
        projectCount: [
          {
            required: true,
            message: "请输入项目最大授权数",
            trigger: "blur",
          },
        ],
        companyAgent: [
          {
            required: true,
            message: "请输入代理商",
            trigger: "blur",
          },
        ],
        receiveMoneyCount: [
          {
            required: true,
            message: "请输入收款金额",
            trigger: "blur",
          },
        ],
        receiveMoneyType: [
          {
            required: true,
            message: "请选择收款方式",
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            message: "请输入备注",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "blur",
          },
        ],
        userAccount: [
          {
            required: true,
            message: "请输入用户账户",
            trigger: "blur",
          },
        ],
        userPwd: [
          {
            validator: (rule, value, callback) => {
              if (this.editId && value === this.originalPassword) {
                callback(); // 编辑时密码未变，跳过校验
              } else if (!value) {
                callback(new Error('请输入用户密码'));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (this.editId && value === this.originalPassword) {
                callback(); // 编辑时密码未变，跳过校验
              } else {
                validatorPassword(rule, value, callback);
              }
            },
            trigger: "blur",
          },
        ],
        projectLeaderPhone: [
          {
            required: true,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
          {
            min: 11,
            max: 11,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        telephone: [
          {
            required: true,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
          {
            min: 11,
            max: 11,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
      },
      unitList: [], //规模列表
      companyId: "",
      projectId: getStore({ name: "projectId" }),
      propsKey: [],
      haveID: "",
      editId: 0,
      pushInformation: false,
      warnLists: [],
      warnListsId: [],
      pushRules: {
        warnType: 10, //同一设备同种监测类型
        warnNum: 5, //连续报警次数
        warnMore: 1, //同意模块超过天数再次报警
      },
      contentText: "",
      warnTodo: {
        isGlobalOpen: false,
        isContinuationOpen: false,
        continuationMinutes: null,
        continuationTimes: null,
        isProruptionOpen: false,
        proruptionDays: 1,
        dailyLimit: null,
        maxLimit: null,
        dailySurplusCount: 15,
        modulesSelectedList: [],
        isFinish: 0
      },
      warnData: [],
    };
  },
  // watch: {
  //   'warnTodo.isProruptionOpen'(val) {
  //     console.log('-------------', val)
  //   },
  // },
  created() {
    this.getList();
    // this.getWarnData();
    Api_Base.getMoneyTypeList().then((res) => {
      this.getMoneyTypeList = res.data.data;
    });

    Api_System.getPlatList().then((res) => {
      this.PlatList = res.data.data;
    });
    Api_System.getProjectType().then((res) => {
      this.projectTypeList = res.data.data;
    });
    Api_System.getUnitType().then((res) => {
      this.unitTypeList = res.data.data;
    });

    Api_SuperAdmin.allList().then((res) => {
      this.belongUnitList = res.data.data;
    });

    Api_SuperAdmin.unitList().then((res) => {
      this.unitList = res.data.data;
    });
  },
  methods: {
    finishInput(e) {
      e === this.warnTodo.isFinish ?
        (this.warnTodo.isFinish = 0)
        : (this.warnTodo.isFinish = e);
    },
    handleCheckChange(val) {
      if (val) {
        this.warnTodo.continuationMinutes = 10;
        this.warnTodo.continuationTimes = 5;
      } else {
        this.warnTodo.continuationMinutes = null;
        this.warnTodo.continuationTimes = null;
      }
    },
    handleCheckChangeDay(val) {
      if (val) {
        this.warnTodo.proruptionDays = 1;
      } else {
        this.warnTodo.proruptionDays = null;
      }
    },
    limitNum() {
      // if (this.warnTodo.dailyLimit > this.warnTodo.maxLimit) {
      //   this.warnTodo.dailyLimit = this.warnTodo.maxLimit;
      // }
    },
    cencelWarn() {
      this.pushInformation = false;
      // this.getWarnData();
    },
    warnSurePush() {
      // this.warnLists.forEach(ele => {
      //   ele.isSelect = false;
      // });
      let tempArr = [];
      for (let { moduleId, isSelect, moduleName } of this.warnLists) {
        const matchedItem = this.warnListsId.find((item) => item === moduleId);
        if (matchedItem) {
          isSelect = true;
        } else {
          isSelect = false;
        }
        tempArr.push({ moduleName, moduleId, isSelect });
      }
      this.warnTodo.modulesSelectedList = tempArr;
      if (this.warnTodo.isContinuationOpen) {
        if (
          !this.warnTodo.continuationMinutes ||
          !this.warnTodo.continuationTimes
        ) {
          this.$showMessage("失败", "连续报警时间或次时不能为空");
          return;
        }
        if (!this.warnTodo.dailyLimit) {
          this.$showMessage("失败", "每日短信推送条数上线不能为空");
          return;
        }
      }
      if (this.warnTodo.isProruptionOpen) {
        if (!this.warnTodo.proruptionDays) {
          this.$showMessage("失败", "报警天数不能为空");
          return;
        }
        if (!this.warnTodo.dailyLimit) {
          this.$showMessage("失败", "每日短信推送条数上线不能为空");
          return;
        }
      }
      this.pushInformation = false;
    },
    handleCloseWarn() {
      this.pushInformation = false;
    },
    // 短信推送配置接口
    async msgSubmit(params, isEdit) {
      const {
        data: { statusCode, errors },
      } = await pushWarnData(params);
      if (statusCode === 200) {
        this.$message({
          type: "success",
          message: isEdit ? '更新成功!' : "设置成功！",
        });
        this.addDialogVisible = false;
        this.form = {
          platFormType: [],
          status: 1,
          authorityCompanyId: 0,
        };
        this.getList();
      } else {
        this.$showMessage("失败", errors);
      }
    },
    getWarnData() {
      let params = {
        projectid: this.editId, // id为0是新建，否则是编辑
      };
      getWarnData(params).then((res) => {
        // this.warnTodo = res.data.data;
        this.warnLists = res.data.data.modulesSelectedList;
        // 推送模块复选框
        this.warnLists.forEach((ele) => {
          if (ele.isSelect) {
            this.warnListsId.push(ele.moduleId);
          }
        });
        //感叹号的提示
        if (this.warnLists.length > 0) {
          for (let i = 0; i < this.warnLists.length - 1; i += 2) {
            if (this.warnLists[i].moduleId < 100) {
              if (this.contentText != "") {
                this.contentText +=
                  "，" +
                  this.warnLists[i].moduleName +
                  "，" +
                  this.warnLists[i + 1].moduleName;
              } else {
                this.contentText +=
                  this.warnLists[i].moduleName +
                  "，" +
                  this.warnLists[i + 1].moduleName;
              }
            }
          }
          this.contentText = "只对" + this.contentText + "模块有效";
        }
        //编辑短信推送 默认数据格式
        let key = ['isContinuationOpen', 'continuationMinutes', 'continuationTimes', 'isProruptionOpen', 'proruptionDays', 'dailyLimit', 'modulesSelectedList']
        for (var i of key) {
          this.$set(this.warnTodo, i, res.data.data[i])
        }
      });
    },
    warnChecked() { },
    warnListRes() { },
    pushDialog(e) {
      e.preventDefault();
      this.pushInformation = true;
    },
    openAdd() {
      this.addDialogVisible = true;
      this.form = {
        platFormType: [],
        status: 1,
        authorityCompanyId: 0,
      };
      this.getWarnData();
    },
    handlerBelongUnit(val) {
      this.belongUnitList.map((item) => {
        if (val === item.companyName) {
          this.form.authorityCompanyId = item.id;
        }
      });
      console.log("单位=====", this.form);
    },
    getModules(val) {
      this.companyId = val.authorityCompanyId;
      this.projectId = val.id;
      Api_SuperAdmin.modulesDetail(val.authorityCompanyId).then((res) => {
        const result = res.data;
        if (result.statusCode == 200) {
          this.haveID = result.data && result.data.authorityMenuId;
          this.getProjectSelect();
        } else {
          this.$message({
            type: "error",
            message: "此公司未设置权限!",
          });
        }
      });
    },
    getProjectSelect() {
      Api_SuperAdmin.getProjectSubSelect(this.projectId).then((res) => {
        const result = res.data;
        if (result.statusCode == 200) {
          this.propsKey = result.data && result.data.authorityMenuId.split(",");
          this.authorizationShow = true;
          this.$refs.authorization.open();
        } else {
          this.propsKey = [];
          this.$showMessage("失败", result.errors);
        }
      });
    },
    selectModules(modules) {
      Api_SuperAdmin.setProjectModules({
        authorityCompanyId: this.companyId,
        authorityProjectId: this.projectId,
        authorityMenuId: modules.join(","),
      }).then((res) => {
        this.$message({
          type: "success",
          message: "设置成功!",
        });
        this.authorizationShow = false;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.add() // 后端要求：先调用弹框确定，拿到结果作为短信的projectId参数
          // this.msgSubmit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.addDialogVisible = false;
      this.warnTodo = {
        isGlobalOpen: false,
        isContinuationOpen: false,
        continuationMinutes: null,
        continuationTimes: null,
        isProruptionOpen: false,
        proruptionDays: null,
        dailyLimit: null,
        dailySurplusCount: 15,
        modulesSelectedList: [],
        isFinish: 0
      };
      this.warnListsId = [];
      this.form = {
        platFormType: [],
        status: 1,
        authorityCompanyId: 0,
      };
      this.$refs[formName].resetFields();
      this.editId = 0;
    },
    edit(item) {
      this.editId = item.id;
      // this.getWarnData();
      // 短信配置详情

      Api_SuperAdmin.projectDetail(item.id).then((res) => {
        item = res.data.data;
        if (item.platFormType && item.platFormType.length != 0) {
          item.platFormType = item.platFormType.split(",");
        } else {
          item.platFormType = [];
        }
        item.selectedOptions = [
          item.provinceId + "",
          item.cityId + "",
          item.areaId + "",
        ];
        // item.authorityCompanyId = item.authorityCompanyId
        this.warnTodo = item;
        this.warnTodo.isFinish = Number(res.data.data.isFinish);
        this.form = item;
        this.originalPassword = item.userPwd; // 新增：保存原始密码
        this.addDialogVisible = true;
        this.getWarnData();//拿到详情后 获取短信接口数据格式 去赋值  this.warnTodo.modulesSelectedList 等
      });
    },
    del(item) {
      this.$confirm("是否删除此项目?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        Api_SuperAdmin.delProject(item.id).then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getList();
        });
      });
    },
    add() {
      this.form.provinceId = this.form.selectedOptions[0];
      this.form.cityId = this.form.selectedOptions[1];
      this.form.areaId = this.form.selectedOptions[2];
      let platFormType = Array.isArray(this.form.platFormType) ? this.form.platFormType.join(",") : this.form.platFormType;
      for (const i in this.belongUnitList) {
        if (this.belongUnitList[i].id === this.form.authorityCompanyId) {
          this.form.belongUnitName = this.belongUnitList[i].companyName;
          break;
        }
      }
      //处理 编辑 platFormType 类型保持[]
      let obj = {
        ...this.form,
        platFormType: platFormType
      }
      if (this.form.id) {
        Api_SuperAdmin.editProject(obj).then((res) => {
          const data = res.data
          if (res.data.statusCode == 200) {
            let params = {
              ...this.warnTodo,
              projectid: this.editId,
            };
            this.msgSubmit(params, true)
          } else {
            this.$message({
              type: "error",
              message: data.errors,
            });
          }
        });
      } else {
        Api_SuperAdmin.addProject(obj).then(async (res) => {
          const data = res.data
          if (data.data) {
            let params = {
              ...this.warnTodo,
              projectid: data.data,
            };
            this.msgSubmit(params, false)
          } else {
            this.$message({
              type: "error",
              message: data.errors,
            });
          }
        });
      }
    },
    getList() {
      Api_SuperAdmin.projectList({
        pageSize: this.pagesize,
        pageIndex: this.currentPage,
        projectType: this.projectTyle,
        projectNam: this.searchKey,
        status: this.status,
      }).then((res) => {
        this.tableData = res.data.data.tList;
        this.totalCount = res.data.data.totalCount;
      });
    },
    handleClose() {
      this.warnListsId = [];
      this.addDialogVisible = false;
    },
    closeAuthor(val) {
      this.authorizationShow = val;
      this.propsKey = [];
      this.companyId = "";
      this.haveID = "";
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.pushInformation {
  width: 100px;
  height: 30px;
  padding: 0 10px;
  background-color: #169bd5;
  cursor: pointer;
  border: none;
  border-radius: 3px;
  color: #fff;
  /deep/ .el-tooltip__popper {
    width: 200px;
  }
}
</style>
<style>
.groupLists .el-checkbox {
  width: 20%;
  margin-right: 4%;
}
</style>
